import React from 'react'
import { Input, Loader } from 'components/common'

export default class TwoFA extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: props.loadQrcodeOnInit == true,
			secret: null,
			qrCodeUrl: null
		}
	}

	setup = () => {
		const { pwdData } = this.props
		const credentials = btoa( JSON.stringify(pwdData) )

		http.post('/users/setup2FA.json', {process: 'start', credentials: credentials}, (response, success) => {
			this.setState({loading: false})
			if (success) {
				this.setState({
					secret: response.secret,
					qrCodeUrl: response.qrCodeUrl
				})
			}
		})
	}

	componentDidMount() {
		if (this.props.loadQrcodeOnInit == true) {
			this.setup()
		}
	}

	onChange2FACode = () => {
		this.forceUpdate()
	}

	onCancel2FA = () => {
		this.setState({
			secret: null,
			qrCodeUrl: null
		})
	}

	onDefine2FA = () => {
		const { pwdData, onSubmitted } = this.props
		const credentials = btoa( JSON.stringify(pwdData) )

		http.post('/users/setup2FA.json', {process: 'end', credentials: credentials}, (response, success) => {
			if (success) {
				const { user } = this.props

				if (user) {
					user.tfa = 1
				}
				this.setState({
					secret: null,
					qrCodeUrl: null
				})
				if (onSubmitted) {
					onSubmitted(response)
				}
			}
		})
	}

	onDefineKeyDown = (e) => {
		if (e.keyCode === 13) {
			this.onDefine2FA()
		}
	}

	renderQrCode = () => {
		const { secret, qrCodeUrl } = this.state
		const { pwdData } = this.props
		const { tfa_code } = pwdData

		if (!secret) {
			return null
		}
		return (
			<>
				<div dangerouslySetInnerHTML={{__html: __('security_2fa_define')}}></div>
				<div className="center">
					<div>{qrCodeUrl ? <img src={qrCodeUrl} /> : null}</div>
					<div>{secret || null}</div>
					<hr />
					<div className='bold'>{__('security_2fa_input_code')}</div>
					<Input model={pwdData} name="tfa_code" maxLength={6} autoFocus
						classNameEl="form-control input-sm input-num center"
						onChange={this.onChange2FACode}
						onKeyDown={this.onDefineKeyDown}
					/>
					<div className="clearfix" /><p/>
					<div className="btn-group">
						<button className='btn btn-success' disabled={!tfa_code} onClick={this.onDefine2FA}>Definir</button>
						<button className='btn btn-default' onClick={this.onCancel2FA}>{__('buttons_cancel')}</button>
					</div>
				</div>
			</>
		)
	}

	render() {
		const { secret, loading } = this.state
		let content = null
		const { user } = this.props

		if (loading) {
			return <Loader />
		}
		if (secret) {
			content = this.renderQrCode()
		}
		else if (user && user.tfa == 1) {
			content =
				<>
					<div>
						<em className="la la-info-circle" />
						{__('security_2fa_defined')}
						<button className='btn btn-primary' onClick={this.setup}>Redefinir 2FA</button>
					</div>
				</>
		}
		else {
			content =
				<>
					<div>
						<em className="la la-info-circle" />
						{__('security_2fa_not_defined')}
						<button className='btn btn-primary' onClick={this.setup}>Iniciar 2FA</button>
					</div>
				</>
		}
		return (
			<div className='pcontent'>
				{content}
			</div>
		)
	}
}
